import * as React from 'react';
import { connect } from 'react-redux';
import { AdminMenu } from '../../components/pages/survey-admin/AdminMenu';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators } from '../../store/SurveyAdminStore';
import { SurveyPreviewActionCreators } from '../../store/SurveyPreviewActionCreators';

export const AdminMenuPage: React.ComponentType<{ surveyId: number }> = connect(
	(state: IApplicationState) => ({
		...state.surveyAdmin,
		...state.confirmSchedule,
	}),
	{ ...ActionCreators, ...NavigationActions, ...SurveyPreviewActionCreators },
)(AdminMenu);
